/**
 * Encode a Blob to a base64 STRING (no `data:` prefix). Audio chunks travel as a
 * base64 string field (`chunkB64`) instead of a binary attachment so socket.io emits
 * a plain EVENT packet — never a BINARY_EVENT — eliminating the binary-attachment
 * reassembly desync that corrupted prod audio buffers on 2026-06-14 (incident:
 * _incidents/2026-06-14-voice-socketio-framing-corruption.md).
 *
 * Uses FileReader.readAsDataURL (not `btoa(String.fromCharCode(...))`) so arbitrarily
 * large blobs encode without blowing the call stack.
 *
 * Shared by the STT path (`useSocket.ts`) and the memo path (`useMemos.ts`, the
 * LogbookModal handler in `App.tsx`) — single source of truth so neither can drift
 * back to a binary emit. Extracted from useSocket.ts in #1622 (memo-path mirror of
 * the #1620 STT fix).
 */
export function blobToBase64(blob: Blob): Promise<string> {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const result = reader.result;
      if (typeof result !== 'string') { reject(new Error('blobToBase64: unexpected reader result')); return; }
      const comma = result.indexOf(',');
      resolve(comma >= 0 ? result.slice(comma + 1) : result);
    };
    reader.onerror = () => reject(reader.error ?? new Error('blobToBase64: read failed'));
    reader.readAsDataURL(blob);
  });
}
